module.exports = __webpack_public_path__ + "img/jcb.99bdf806.svg";